export default __webpack_public_path__ + "static/media/pic2art-icon2.ec845b20.svg";